var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaperBin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_762_1853)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.2146 6.86366H32.5621C31.5891 6.86366 30.7974 6.07203 30.7974 5.09891V0.5H17.2027V5.09891C17.2027 6.07203 16.4111 6.86366 15.4379 6.86366H4.7854V16.6004H8.64424V48.5H39.3558V16.6004H43.2146V6.86366ZM20.0152 5.09891V3.3125H27.9849V5.09891C27.9849 5.72412 28.1112 6.32028 28.3391 6.86366H19.661C19.8889 6.32028 20.0152 5.72412 20.0152 5.09891ZM36.5433 45.6875H11.4567V16.6004H36.5433V45.6875ZM40.4021 13.7879H7.5979V9.67616H40.4021V13.7879H40.4021Z",
    fill: "#19A69D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.619 20.7774H18.4315V41.6775H15.619V20.7774Z",
    fill: "#19A69D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5938 20.7774H25.4062V41.6775H22.5938V20.7774Z",
    fill: "#19A69D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5685 20.7774H32.381V41.6775H29.5685V20.7774Z",
    fill: "#19A69D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_762_1853"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperBin);
export default __webpack_public_path__ + "static/media/paper-bin.5752c9d096601be26e371f9719282e13.svg";
export { ForwardRef as ReactComponent };